import type { SettingsFlowProps } from '@psl/flows/settings/SettingsFlowContent';
import { SettingsFlowContextProvider } from '@psl/flows/settings/SettingsFlowContext';
import { lazy } from 'react';
import { adaptiveWrapperOptions } from '../../appComponents/ModalWrapper';
import { screenOptionsForLightMode } from '../../functions/navigation/screenOptions';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const SettingsFlowContent = lazy(() => import('./SettingsFlowContent'));

const SettingsFlow = wrapLazyNavigatorScreen(
  (props: SettingsFlowProps) => {
    return (
      <SettingsFlowContextProvider>
        <SettingsFlowContent {...props} />
      </SettingsFlowContextProvider>
    );
  },
  adaptiveWrapperOptions(isMobile =>
    isMobile
      ? screenOptionsForLightMode({
          presentation: 'card',
        })
      : screenOptionsForLightMode({
          presentation: 'transparentModal',
          cardOverlayEnabled: true,
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: false,
          headerShown: false,
        }),
  ),
);

export default SettingsFlow;
